<template>
  <div class="mx-auto">
    <b-row >
      <b-col xxs="12">
        <div class="row my-5">
          <div class="col-lg-8">
            <h1 class="m-0 p-0 font-weight-boldest mega-text">
              Contact Us
            </h1>
            <h6 class="font-weight-bold">
              Get in touch with us if you have any questions.
            </h6>
          </div>
        </div>

        <div class="row no-gutters bg-white mb-5">
        
          <div class="col-12">
            <b-list-group flush>
              <b-list-group-item style="background: transparent">
               <br> <i class="lni lni-envelope font-size-26 text-primary"></i> <br><br>
                <a href="mailto:zaid@rapidsoft.co.za" class="text-body"
                  >zaid@rapidsoft.co.za</a
                ></b-list-group-item
              >
              <b-list-group-item style="background: transparent"
                ><br><i class="lni lni-phone-set font-size-26 text-primary"></i> <br><br><a href="tel:+27118392645"
                 class="text-body" >(27) 11 839 2645</a
                ></b-list-group-item
              >
              <b-list-group-item style="background: transparent">
               <br> <i class="lni lni-map-marker font-size-26 text-primary"></i><br><br>
                11 Magalies Street Hurst Hill<br />
                2092<br />
                Johannesburg<br />
                South Africa</b-list-group-item
              >

              <b-list-group-item style="background: transparent"
                >
                <br>
                <i class="lni lni-protection text-primary font-size-26"></i>
                <br>   <br>
                <p class="mb-3">
                  Propli.xyz is a product of Rapdisoft.<br><br>
                  RapidSoft is based in Hurst Hill, Johannesburg, South Africa, with our client base extending across South Africa, Namibia and Zambia. The company was established in July 1995, and has since been developing customized solutions as well as packaged software for Corporate Clients and SMME's. At RapidSoft, our premier skills have placed us on a platform where we have served a diverse client base which includes:<br><br>
<ul>
<li>Telecommunication companies</li>
<li>Wholesalers</li>
<li>Manufacturers</li>
<li>Transport companies</li>
<li>Cellular Repair Centre</li>
<li>Insurance Companies</li>
<li>Retailers</li>
<li>Service Providers</li>
<li>Medical Bureau</li>
<li>Chain Stores</li>
</ul>

                  <br>
                  <a href="">rapidsoft.co.za</a>
                </p>
              </b-list-group-item>
            </b-list-group>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appName: process.env.VUE_APP_APP_NAME,
    };
  },
};
</script>
